<h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">
  {{ 'Spørreundersøkelser du skal besvare'|translate }}
  <button mat-icon-button type="button" (click)="lukk()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<div class="panel-skrollkontainer" [style.max-height.px]="maksPopupHoeyde() - 40"><!-- -40 for å ta høyde for høyden til overliggende h2 -->
  <section data-testid="du-skal-besvare">
    @if (ubesvartAvBruker().length === 0) {
      <div class="ingen-undersøkelser">
        {{ 'Du har besvart alle spørreundersøkelsene'|translate }}
        <mat-icon>celebration</mat-icon>
      </div>
    }

    @for (innslag of ubesvartAvBruker(); track innslag.undersoekelse.id) {
      <div (click)="besvarUndersoekelse(innslag.undersoekelse)" class="rad egne" data-testid="undersoekelse">
        <mat-icon class="panel-entitet-ikon">content_paste_search</mat-icon>
        <a class="tittel">
          <div data-testid="tittel">{{ innslag.undersoekelse.tittel }} {{ gruppeinfo(innslag.undersoekelse.eiendeGruppeId) }}</div>
          <div class="sub-tittel">
            {{ 'Svarfrist {dato}'|translate:{dato: innslag.undersoekelse.responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}.
            @switch (innslag.status) {
              @case (statuser.ikke_besvart) {
                {{ "Du har ikke besvart" | translate }}
              }
              @case (statuser.delvis_besvart) {
                {{ "Du har besvart noen av spørsmålene" | translate }}
              }
              @case (statuser.besvart) {
                {{ "Du har besvart alle spørsmålene" | translate }}
              }
            }
          </div>
        </a>
        <span class="svar-knapp">
          <button mat-stroked-button color="primary" type="button" (click.stopp)="besvarUndersoekelse(innslag.undersoekelse)" data-testid="svar-knapp">
            @switch (innslag.status) {
              @case (statuser.ikke_besvart) {
                {{ "Svar" | translate }}
              }
              @default {
                {{ "Oppdater svar" | translate }}
              }
            }
          </button>
        </span>
      </div>
    }
  </section>

  @if (harSkrivetilgang()) {
    <section data-testid="andre-skal-besvare">
      <h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">{{ 'Spørreundersøkelser andre skal besvare'|translate }}</h2>

      @if (ubesvartAvAndre().length === 0) {
        <div class="ingen-undersøkelser">
          {{ 'Alle andre har besvart alle spørreundersøkelser'|translate }}
          <mat-icon>celebration</mat-icon>
        </div>
      }

      @for (ubesvart of ubesvartAvAndre(); track ubesvart.undersoekelse.id) {
        <div class="rad andres" data-testid="undersoekelse">
          <mat-icon (click)="gaaTilUndersoekelse(ubesvart.undersoekelse)" class="panel-entitet-ikon">content_paste_search</mat-icon>
          <a (click)="gaaTilUndersoekelse(ubesvart.undersoekelse)" class="tittel">
            <div data-testid="tittel">{{ ubesvart.undersoekelse.tittel }} {{ gruppeinfo(ubesvart.undersoekelse.eiendeGruppeId) }}</div>
            <div class="sub-tittel">
              {{ 'Svarfrist {dato}'|translate:{dato: ubesvart.undersoekelse.responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}
            </div>
          </a>
          <div (click)="visEllerSkjulRespondenter(ubesvart.undersoekelse.id)" class="antall" data-testid="vis-skjul-respondenter-knapp">
            {{ '{antall} av {total} har besvart'|translate:{antall: antallSomHarBesvart(ubesvart), total: ubesvart.respondenter.length} }}
          </div>
          @if (viserRespondenterSignal(ubesvart.undersoekelse.id)()) {
            <div class="respondentstatus" @fadeInn>
              <div class="respondenter" data-testid="respondenter">
                @for (respondent of ubesvart.respondenter; track respondent.medlem.id) {
                  <div class="respondent">
                    <avatar [medlem]="respondent.medlem"></avatar>
                    <div>
                      <div data-testid="navn">{{ respondent.medlem.navn }}</div>
                      @if (respondent.status == statuser.ikke_besvart) {
                        <!-- <div class="påminnelse">{{ purringSendeOmAntallDager(signatarer) }}</div>-->
                      }
                    </div>
                    @switch (respondent.status) {
                      @case (statuser.ikke_besvart) {
                        <div class="status ikke-besvart" data-testid="status">
                          {{ "Ikke besvart" | translate }}
                        </div>
                      }
                      @case (statuser.delvis_besvart) {
                        <div class="status" data-testid="status">
                          {{ "Delvis besvart" | translate }}
                        </div>
                      }
                      @case (statuser.besvart) {
                        <div class="status" data-testid="status">
                          {{ "Besvart" | translate }}
                        </div>
                      }
                    }
                  </div>
                }
              </div>
              <!--<div class="handlinger">
                <button mat-stroked-button type="button" (click)="sendPurring(dokumentId)" matTooltip="{{'Åpner dialog som lar deg sende påminnelse til de som ikke har signert'|translate}}">
                  {{ 'Send påminnelse'|translate }}
                </button>
                <button mat-stroked-button type="button" color="warn" (click)="avsluttSignering(dokumentId)" matTooltip="{{'Åpner dialog som lar deg avslutte signeringsprosessen'|translate}}">
                  {{ 'Avslutt signering'|translate }}
                </button>
              </div>-->
            </div>
          }
        </div>
      }
    </section>
  }
</div>

